import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { dispatchEvent, subscribe, translate } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { distinctUntilChanged, tap } from 'rxjs';
import { DisconnectEventModel } from '../disconnect/disconnect-event-model';
import './elements/wallet-list';
import { walletManageStyle } from './wallet-manage.style';
let WalletManageElement = class WalletManageElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
    }
    static { this.tagName = 'inch-wallet-manage'; }
    static { this.styles = walletManageStyle; }
    onDisconnectClick() {
        dispatchEvent(this, DisconnectEventModel.EVENT_TYPE, new DisconnectEventModel());
    }
    firstUpdated() {
        subscribe(this, this.applicationContext.value.wallet.data.isConnected$.pipe(distinctUntilChanged(), tap((connected) => (this.connected = connected))));
    }
    render() {
        return html `
      <div class="wallet-manager-container">
        <div class="wallet-manager-container-list">
          <inch-wallet-list></inch-wallet-list>
        </div>
        ${when(this.connected, () => html `
            <div class="wallet-manager-actions">
              <inch-button
                class="bnt-action__resize"
                @click="${() => this.onDisconnectClick()}"
                type="primary-critical"
                size="xl"
                fullsize
              >
                ${translate('widgets.wallet-manager.button.disconnect')}
              </inch-button>
            </div>
          `)}
      </div>
    `;
    }
};
__decorate([
    state(),
    __metadata("design:type", Boolean)
], WalletManageElement.prototype, "connected", void 0);
WalletManageElement = __decorate([
    customElement(WalletManageElement.tagName)
], WalletManageElement);
export { WalletManageElement };
//# sourceMappingURL=wallet-manage.element.js.map